(function initProductPageAccordion() {
  function bindAccordions(root = document) {
    root.querySelectorAll('.template-product .product-details .accordion').forEach((accordion) => {
      if (accordion.dataset.accordionBound === 'true') return;
      accordion.dataset.accordionBound = 'true';

      accordion.addEventListener(
        'click',
        (event) => {
          const summary = event.target.closest('summary');
          if (!summary || !accordion.contains(summary)) return;

          const detail = summary.closest('details');
          if (!(detail instanceof HTMLDetailsElement)) return;

          event.preventDefault();

          const shouldOpen = !detail.open;

          accordion.querySelectorAll('details').forEach((item) => {
            item.open = false;
          });

          if (shouldOpen) {
            detail.open = true;
          }
        },
        true
      );
    });
  }

  bindAccordions();

  document.addEventListener('shopify:section:load', (event) => {
    bindAccordions(event.target);
  });
})();
